module.exports = __webpack_public_path__ + "img/lolly-product.b99cafa0.png";